import { useCustomizerSpace } from '../hooks/index.js'
import { SlateEditor, SlateTree } from '../SlateEditor/index.js'

export const PostTypeSidebarEditor = () => {
  const { postType } = useCustomizerSpace()

  if (!postType?.slate) {
    return null
  }

  return (
    <SlateEditor slates={[{ id: postType.id, slate: postType.slate }]}>
      <div className="-ms-3 -me-3">
        <SlateTree id={postType.id} />
      </div>
    </SlateEditor>
  )
}
